module.exports = __webpack_public_path__ + "static/bsas019-2cf65a3d919f64a2b79f3cf2fc21bc07.jpg";